import React from "react";
import "./Toggle.scss";

export const Toggle = ({ status, setStatus }) => {
  const hadleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setStatus((prev) => !prev);
  };

  return (
    <button className="toggle-container" onClick={hadleClick} tabIndex={0} aria-label="toggle">
      <div className={`toggle-element ${status ? "on" : "off"}`}></div>
    </button>
  );
};
